import React from 'react';
import moment from 'moment';
import { Field } from 'formik';
import { Form, InputGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { regionDateAndTime } from 'utils';

const ReactstrapFormikDatePickerCheckbox = ({
    field: { ...fields },
    form: { values, touched, errors, setFieldValue, setFieldTouched },
    ...props
}) => {
    const { id, ...rest } = props;
    const isCheckboxName = `is_${fields.name}`;
    return (
        <Form.Group className="form-group">
            {props.label && <Form.Label className={'label-color'}>{props.label}</Form.Label>}
            <InputGroup>
                <div className="input-group-prepend">
                    <InputGroup.Text>
                        <Field
                            name={isCheckboxName}
                            render={({ field }) => (
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id={isCheckboxName}
                                        checked={field.value}
                                        {...field}
                                        onChange={(e) => {
                                            if (!e.target.checked) {
                                                setFieldValue(fields.name, null);
                                            }
                                            setFieldValue(isCheckboxName, e.target.checked);
                                        }}
                                        onBlur={() => {
                                            setFieldTouched(isCheckboxName, true);
                                        }}
                                    />
                                    <label className="custom-control-label pb-0" htmlFor={isCheckboxName}></label>
                                </div>
                            )}
                        />
                    </InputGroup.Text>
                </div>
                <Form.Control
                    as={DatePicker}
                    {...rest}
                    {...fields}
                    selected={(fields.value && new Date(fields.value)) || null}
                    value={
                        fields.value !== null && moment(fields.value).format(regionDateAndTime()?.GENERAL_DATE_FORMAT)
                    }
                    disabled={!values[isCheckboxName]}
                    onChange={(e) => {
                        setFieldTouched(fields.name, true);
                        setFieldValue(fields.name, e);
                    }}
                    isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                    popperClassName={fields.value ? '' : 'highlight-today'}
                />
            </InputGroup>
            {touched[fields.name] && errors[fields.name] && errors[fields.name] !== 'required' && (
                <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                    {errors[fields.name]}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};
export default ReactstrapFormikDatePickerCheckbox;
